import { useHistory, useLocation } from "react-router-dom";
import "./back-button.css";

const BackButton = ({
  children = "Back",
  className = "",
  onClick,
  mobileOnly = false,
}) => {
  const history = useHistory();
  const location = useLocation();

  if (["/dashboard","/login","/"].includes(location.pathname)) {
    return null;
  }

  const handleBack = () => {
    if (onClick) {
      onClick();
      return;
    }
    history.goBack();
  };
  const button = (
    <button
      type="button"
      className={`main-back-button ${className}`}
      onClick={handleBack}
    >
      <span className="back-icon">←</span>
      <span>{children}</span>
    </button>
  );
  if (mobileOnly) {
    return <div className="mobile-back-button-wrapper">{button}</div>;
  }
  return button;
};
export default BackButton;
